import type { PaymentInfo } from '@vy/types';
import { fromNullToUndefined } from '@vy/utils';
import type { PaymentInfoFormType } from '../mark-as-paid-form-type';

export function mapPaymentFormValuesToSchema(formValues: PaymentInfoFormType): PaymentInfo {
  return {
    ...formValues,
    date: fromNullToUndefined(formValues.date),
  };
}
